module.exports = require('./lib/type');



//////////////////
// WEBPACK FOOTER
// ./node_modules/deep-eql/node_modules/type-detect/index.js
// module id = 1200
// module chunks = 16